<template>
  <div>
    <sweet-modal blocking :title="isCreate ? 'Create Contact' : 'Update Contact'" ref="modal" class="modal" v-on:close="closeModal('form')">
      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">

        <el-tabs v-model="activeName" style="margin-bottom: 20px;">
          <el-tab-pane label="General" name="general">
            <!-- General -->
            <el-card shadow="never">

              <el-form-item prop="name">
                <el-input label="Contact name (required)" v-model="form.name" maxlength="100" show-word-limit></el-input>
              </el-form-item>

              <el-form-item prop="accountNumber">
                <el-input label="Account number" v-model="form.accountNumber"></el-input>
              </el-form-item>

              <h4>Primary person</h4>

              <el-row :gutter="20">
                <el-col :span="12" :offset="0">
                  <el-form-item prop="firstName">
                    <el-input label="First Name" v-model="form.firstName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item prop="lastName">
                    <el-input label="Last Name" v-model="form.lastName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item prop="emailAddress">
                <el-input label="Email" v-model="form.emailAddress"></el-input>
              </el-form-item>

              <!-- <el-form-item prop="website">
                <el-input label="Website" v-model="form.website"></el-input>
              </el-form-item> -->

              <el-form-item prop="companyNumber">
                <el-input label="Business registration number" v-model="form.companyNumber"></el-input>
              </el-form-item>

              <!-- <el-form-item prop="notes">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="Business registration number"
                  v-model="form.notes"
                  maxlength="4000"
                  show-word-limit>
                </el-input>
              </el-form-item> -->

              <el-form-item prop="salesDefaultAccountCode">
                <el-select v-model="form.salesDefaultAccountCode" placeholder="Sales account" clearable filterable style="width: 100%;">
                  <el-option v-for="item in directoriesList.accounts"
                    :key="item.AccountID"
                    :label="`${item.Code} - ${item.Name}`"
                    :value="item.Code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="xeroNetworkKey">
                <el-input label="Xero network key" v-model="form.xeroNetworkKey"></el-input>
              </el-form-item>

              <el-form-item prop="purchasesDefaultAccountCode">
                <el-select v-model="form.purchasesDefaultAccountCode" placeholder="Purchase account" clearable filterable style="width: 100%;">
                  <el-option v-for="item in directoriesList.accounts"
                    :key="item.AccountID"
                    :label="`${item.Code} - ${item.Name}`"
                    :value="item.Code">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="contactNumber">
                <el-input label="Contact Number" v-model="form.contactNumber"></el-input>
              </el-form-item>

              <el-form-item prop="bankAccountDetails">
                <el-input label="Bank Account Details" v-model="form.bankAccountDetails"></el-input>
              </el-form-item>

              <el-form-item prop="taxNumber">
                <el-input label="Tax Number" v-model="form.taxNumber"></el-input>
              </el-form-item>

            </el-card>
          </el-tab-pane>
          <el-tab-pane label="Addresses" name="addresses">
            <!-- Addresses -->
            <el-card shadow="never">

              <!-- TODO: -->
              Under development

            </el-card>
          </el-tab-pane>
        </el-tabs>

        <el-form-item>
          <div class="btn__flex-end">
            <div v-if="isCreate">
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="createContact('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
            <div v-else>
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="updateContact('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'create-update-modal',
    components: {
      SweetModal
    },
    data() {
      return {
        isCreate: true,
        currentRow: null,
        activeName: 'general',
        directoriesList: null,

        form: {
          // General
          name: '',
          accountNumber: '',
          firstName: '',
          lastName: '',
          emailAddress: '',
          // website: '', // ?
          companyNumber: '',
          // notes: '', // ?
          salesDefaultAccountCode: '',
          xeroNetworkKey: '',
          purchasesDefaultAccountCode: '',
          contactNumber: '',
          bankAccountDetails: '',
          taxNumber: ''
        },

        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          emailAddress: [
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      async openModal({ isCreate = true, currentRow = {} }) {
        this.isCreate = isCreate
        this.currentRow = currentRow
        await this.getDirectories()
        if (!isCreate) {
          await this.handleUpdate()
        }
        this.activeName = 'general'
        this.$refs.modal.open()
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      closeModal(ref){
        this.$refs[ref].resetFields();
      },
      async getDirectories() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/xero/contacts/directories?companyId=${this.$route.query.companyId}`)
          this.directoriesList = data.directories
        } catch (error) {
          console.log('An error occurred:', error);
        } finally {
          loader.hide()
        }
      },
      createContact(form){
        this.$refs[form].validate(async (valid, object) => {
          if (valid) {
            let loader = this.$loading.show()
            try {
              const cloneObj = _.cloneDeep(this.form)
              for (const key in cloneObj)
                if (cloneObj[key] === '') delete cloneObj[key]
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/xero/contacts?companyId=${this.$route.query.companyId}`, cloneObj)
              this.$refs.modal.close()
              this.$emit('loadList')
            } catch (error) {
              console.log('An error occurred:', error)
            } finally {
              loader.hide()
            }
          } else {
            if (object.name) this.activeName = 'general'
          }
        });
      },
      async handleUpdate() {
        let loader = this.$loading.show()
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/xero/contacts?companyId=${this.$route.query.companyId}&id=${this.currentRow.ContactID}`)
          for (const key in this.form) {
            if (data.item.hasOwnProperty(key[0].toUpperCase() + key.slice(1)))
              this.form[key] = data.item[key[0].toUpperCase() + key.slice(1)]
          }
          // this.form.name = data.item.Name
          // this.form.accountNumber = data.item.AccountNumber ? data.item.AccountNumber : ''
          // this.form.firstName = data.item.FirstName ? data.item.FirstName : ''
          // this.form.lastName = data.item.LastName ? data.item.LastName : ''
          // this.form.emailAddress = data.item.EmailAddress ? data.item.EmailAddress : ''
          // this.form.companyNumber = data.item.CompanyNumber ? data.item.CompanyNumber : ''
          // this.form.salesDefaultAccountCode = data.item.SalesDefaultAccountCode ? data.item.SalesDefaultAccountCode : ''
          // this.form.xeroNetworkKey = data.item.XeroNetworkKey ? data.item.XeroNetworkKey : ''
          // this.form.purchasesDefaultAccountCode = data.item.PurchasesDefaultAccountCode ? data.item.PurchasesDefaultAccountCode : ''
          // this.form.contactNumber  = data.item.ContactNumber ? data.item.ContactNumber : ''
          // this.form.bankAccountDetails  = data.item.BankAccountDetails ? data.item.BankAccountDetails : ''
          // this.form.taxNumber  = data.item.TaxNumber ? data.item.TaxNumber : ''
        } catch (error) {
          console.log('An error occurred:', error)
        } finally {
          loader.hide()
        }
      },
      updateContact(form){
        this.$refs[form].validate(async (valid, object) => {
          if (valid) {
            let loader = this.$loading.show()
            try {
              const cloneObj = _.cloneDeep(this.form)
              for (const key in cloneObj)
                if (cloneObj[key] === '') delete cloneObj[key]
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.put(`/api/v1/xero/contacts?companyId=${this.$route.query.companyId}&id=${this.currentRow.ContactID}`, cloneObj)
              this.$refs.modal.close()
              this.$emit('loadList')
            } catch (error) {
              console.log('An error occurred:', error)
            } finally {
              loader.hide()
            }
          } else {
            if (object.name) this.activeName = 'general'
          }
        });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>